import gql from "graphql-tag";

export default gql`
  mutation DeleteRoomTemplate($roomTemplateId: ID, $contractId: ID, $customerId: ID) {
    deleteRoomTemplate(roomTemplateId: $roomTemplateId, contractId: $contractId, customerId: $customerId) {
      id
    }
  }
`;
